<!--  -->
<template>
  <div class="div_ucPOIFuzzyKey">
    <div>
      <el-input
        id="txtFuzzyKey"
        type="text"
        v-model="fuzzyKey" @keyup.enter.native="_imgSearchClickHandler"
        @focus="_inputFuzzyKeyFocusHandler"
        @input="_inputFuzzyKeyChangeHandler"
      >
        <i
          slot="suffix"
          class="el-input__icon el-icon-search"
          style="cursor:pointer"
          @click="_imgSearchClickHandler"
        ></i>
      </el-input>

      <UCPOISuggestKey
        ref="ucSuggestKey"
        v-show="ucSetting.ucSuggestKeyVisibility"
      ></UCPOISuggestKey>

    </div>
  </div>
</template>

<script>
import { POISearchFilter } from "../model/POISearch.js";
import UCPOISuggestKey from "./UCPOISuggestKey.vue";
import { UCPOISearchEvent } from "./UCPOISearchJs";

export default {
  name: "UCPOIFuzzyKey",
  data() {
    return {
      ucSetting: {
        ucSuggestKeyVisibility: false
      },

      //模糊查询关键字
      fuzzyKey: null,

      //当前地图
      curMap: null
    };
  },

  components: { UCPOISuggestKey },

  computed: {},

  mounted() {},

  methods: {

    /**
     * 清空输入框
     */
    clearInput()
    { 
        this.fuzzyKey="";

        //隐藏输入框
        this.ucSetting.ucSuggestKeyVisibility = false;
    },

    off_suggestPoiItemClick(callback) {
      if(callback)
      {
        this.$refs.ucSuggestKey.off_poiItemClick(callback);
      }
    },

    on_suggestPoiItemClick(callback) {
      if(callback)
      {
        this.$refs.ucSuggestKey.on_poiItemClick(callback);
      }
    },

    off_poiSearchClick(callback) {
      if(callback)
      {
        this.$off(UCPOISearchEvent.UCPOIFuzzyKey_poiSearchClick, callback);
      }
    },

    on_poiSearchClick(callback) {
      if(callback)
      {
        this.$on(UCPOISearchEvent.UCPOIFuzzyKey_poiSearchClick, callback);
      }
    },

    off_UCPOIInputFocus(callback)
    {
      if(callback)
      {
        this.$off(UCPOISearchEvent.UCPOIFuzzyKey_inputFocusClick, callback);
      }
    },

    on_UCPOIInputFocus(callback)
    {
      if(callback)
      {
        this.$on(UCPOISearchEvent.UCPOIFuzzyKey_inputFocusClick, callback);
      }
    },
    
    /**
     * 隐藏建议词uc
     */
    hiddenUCSuggestKey() {
      this.ucSetting.ucSuggestKeyVisibility = false;
    },

    _inputFuzzyKeyChangeHandler() {
      if (this.fuzzyKey) {
        this.ucSetting.ucSuggestKeyVisibility = true;

        let filter = POISearchFilter.createFilterFromMap(this.curMap);
        filter.keyWord = this.fuzzyKey;
        this.$refs.ucSuggestKey.curFilter = filter;
        this.$refs.ucSuggestKey.init();
      } else {
        this.ucSetting.ucSuggestKeyVisibility = false;
      }
    },

    _inputFuzzyKeyFocusHandler()
    { 
      this.$emit(UCPOISearchEvent.UCPOIFuzzyKey_inputFocusClick,null);
    },

    _imgSearchClickHandler() {
      //显示结果面板
      //   this.showResultPanel();
      if (!this.fuzzyKey || !this.fuzzyKey.trim()) return;

      this.$emit(UCPOISearchEvent.UCPOIFuzzyKey_poiSearchClick, this.fuzzyKey);

      // let filter = POISearchFilter.createFilterFromMap(this.curMap);
      // filter.keyWord = this.fuzzyKey;

      // this.$refs.ucResultPaging.curFilter = filter;
      // this.$refs.ucResultPaging.init();
    }
  }
};
</script>
<style lang="scss" scoped>

.div_ucPOIFuzzyKey
{ 
  width:100%;
  height: 100%;
}



// .sou-input {
//       width: 100%;
//       height: 55px;
//       position: relative;
//       .l-img {
//         position: absolute;
//         left: 12px;
//         top: 15px;
//       }
//       .r-img {
//         position: absolute;
//         right: 59px;
//         top: 15px;
//       }

//       // input {
//       //   width: 325px;
//       //   height: 100%;
//       //   border: 1px solid #d3d3d3;
//       //   box-shadow: 0 0 4px 0 hsla(0, 0%, 40%, 0.65);
//       //   padding: 0 50px;
//       //   box-sizing: border-box;
//       // }
//     }
</style>